import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJImageToVideoButton from '../view/FJImageToVideoButton';
import FJUtil from '../../../../util/FJUtil.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';

const FJImageToVideoButtonContainer = props => {
    useLocalStore();
    const { isOnlyBtn = false } = props;
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isCanDownload = useSelector(state => state.common.isDone);

    const _imageToVideo = () => {
        dispatch(FJActionCommon.imageToVideoAction());
    };

    if (
        FJUtil.isGeneratingStatus(taskStatus) ||
        taskStatus === FJConstant.ERROR ||
        headerTabIndex !== FJConstant.CREATIONS ||
        !isCanDownload
    ) {
        return null;
    }

    if (window.isEditPage) return null;

    return <FJImageToVideoButton imageToVideo={_imageToVideo} isOnlyBtn={isOnlyBtn} />;
};

export default FJImageToVideoButtonContainer;
